<div class="modal fade show" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"> {{ 'meetings.View Multiple Slides' | translate }} </h4>

        <button type="button" class="close" aria-label="Close" (click)="cancelPop.emit()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body p-3">
        <div class="table-container m-0">
          <table class="table">
            <thead>
              <tr>
                <th class="mat-header-cell"></th>
                <th class="mat-header-cell">{{'meetings.Slide No.' | translate}}</th>
                <th class="mat-header-cell">{{'meetings.Stain type' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let slide of slides; index as i">
                <tr class="mat-row">
                  <td class="mat-cell" width="1%">
                    <mat-checkbox class="my-2 d-block" [(ngModel)]="slide.checked"></mat-checkbox>
                  </td>
                  <td class="mat-cell"
                    (click)="slide.checked = !slide.checked">#{{i+1}}</td>
                  <td class="mat-cell text-left"
                    (click)="slide.checked = !slide.checked">{{slide.stainType.name || notFound}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <p class="has-error" *ngIf="isSubmited && hasError == 'required'">{{'messages.required' | translate}}</p>
          <p class="has-error" *ngIf="isSubmited && hasError == 'max'">{{'meetings.Maximum slide visibility is 4 slides' | translate}}</p>
        </div>


        <div class="modal-btns mt-5">
          <button type="reset" class="close closebtn" (click)="cancelPop.emit()">
            {{ 'swalMsg.cancel' | translate }}
          </button>
          <button matRipple class="btn customBtn px-4" (click)="viewSlides()">
            {{ 'meetings.View Slides' | translate }}
          </button>
        </div>

      </div>

    </div>
  </div>
</div>
